var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vx-card",
    { staticClass: "fill", attrs: { "title-color": "primary" } },
    [
      _c("filtros", {
        attrs: {
          filtersView: _vm.configuration,
          periodos: _vm.periodos,
          source: _vm.source,
          clear: _vm.clearFilters
        },
        on: { "filtros-aplicados": _vm.onChangeFilters }
      }),
      _c("div", {
        staticStyle: {
          clear: "both",
          "border-bottom": "solid 1px #ccc",
          "margin-bottom": "10px"
        }
      }),
      _vm.firstSearch
        ? _c("div", { staticClass: "message" }, [
            _vm._v(
              ' Para realizar una busqueda agrega algunos filtros y luego presiona el boton "Aplicar Filtros" arriba a la izquierda. '
            )
          ])
        : _vm._e(),
      _vm.noResults
        ? _c("div", { staticClass: "message" }, [
            _vm._v(
              " Oh no! no logramos encontrar nada con los filtros que ingresaste, verificalos o prueba quitando algunos. "
            )
          ])
        : _vm._e(),
      _vm.loading
        ? _c("div", { staticClass: "message" }, [
            _vm._v(
              " Buscando los elementos que coincidan con los filtros de busqueda ingresados... "
            )
          ])
        : _vm._e(),
      _c(
        "vs-row",
        { staticClass: "bg-white shadow py-5 px-3 mb-4" },
        [
          _c("vs-col", { attrs: { "vs-lg": "6" } }, [
            _c("b", [_vm._v("Nombre")])
          ]),
          _c("vs-col", { attrs: { "vs-lg": "5" } }, [
            _c("b", [_vm._v("Autor")])
          ]),
          _c("vs-col", { attrs: { "vs-lg": "1" } }, [_c("b", [_vm._v("...")])])
        ],
        1
      ),
      _vm._l(_vm.resultAguasAndinas, function(item, index) {
        return _c("open-text-row", {
          key: "object-" + index,
          attrs: { doc: item, source: _vm.source },
          on: { download: _vm.download }
        })
      }),
      _vm.source === "egestion" && _vm.pagination.totalPages > 1
        ? _c(
            "vs-row",
            { staticClass: "py-4 justify-content-center align-items-center" },
            [
              _c(
                "vs-col",
                { staticClass: "text-center", attrs: { "vs-lg": "12" } },
                [
                  _c(
                    "vs-button",
                    {
                      staticClass: "mr-2",
                      attrs: {
                        size: "small",
                        disabled: _vm.pagination.page <= 1
                      },
                      on: { click: _vm.prevPage }
                    },
                    [_vm._v(" Anterior ")]
                  ),
                  _c("span", { staticClass: "mx-3" }, [
                    _vm._v(
                      " Pagina " +
                        _vm._s(_vm.pagination.page) +
                        " de " +
                        _vm._s(_vm.pagination.totalPages) +
                        " (" +
                        _vm._s(_vm.pagination.total) +
                        " documentos) "
                    )
                  ]),
                  _c(
                    "vs-button",
                    {
                      staticClass: "ml-2",
                      attrs: {
                        size: "small",
                        disabled:
                          _vm.pagination.page >= _vm.pagination.totalPages
                      },
                      on: { click: _vm.nextPage }
                    },
                    [_vm._v(" Siguiente ")]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }